import { Group } from '@mantine/core';
import { FormattedMessage } from 'react-intl';

import { Tag } from '@shipstation/client-common/components/tag';

import { CONNECTION_STATUS } from '../../../../../../../../inventory-sync/types/inventory-sync-types';
import { SyncErrorPopover } from './sync-error-popover';
import { messages } from '../connection-sync-table.messages';

import type { ProductConnectionSyncRow } from '../../../product-inventory-sync-types';

const STATUS_GAP = 4;

export const ConnectionSyncStatusCell = ({ row }: { row: ProductConnectionSyncRow }) => {
  if (row.hasSyncError) {
    return (
      <Group gap={STATUS_GAP} wrap='nowrap'>
        <Tag.System color='alert' shouldShowDot variant='outline'>
          <FormattedMessage {...messages.statusSyncFailed} />
        </Tag.System>
        {row.syncErrorMessage && <SyncErrorPopover message={row.syncErrorMessage} />}
      </Group>
    );
  }

  if (row.isSyncing) {
    return (
      <Tag.System color='info' shouldShowDot variant='outline'>
        <FormattedMessage {...messages.statusSyncing} />
      </Tag.System>
    );
  }

  if (row.ineligibleReason !== null) {
    return (
      <Tag.System color='neutral' shouldShowDot variant='outline'>
        <FormattedMessage {...messages.statusInactive} />
      </Tag.System>
    );
  }

  const isActive = row.connectionStatus === CONNECTION_STATUS.active;

  return (
    <Tag.System color={isActive ? 'success' : 'alert'} shouldShowDot variant='outline'>
      <FormattedMessage {...(isActive ? messages.statusActive : messages.statusInactive)} />
    </Tag.System>
  );
};
